import { render, staticRenderFns } from "./IdentityVerification.vue?vue&type=template&id=9975c72e&scoped=true"
import script from "./IdentityVerification.vue?vue&type=script&lang=js"
export * from "./IdentityVerification.vue?vue&type=script&lang=js"
import style0 from "./IdentityVerification.vue?vue&type=style&index=0&id=9975c72e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9975c72e",
  null
  
)

export default component.exports